module.exports = __webpack_public_path__ + "img/wechat-noti-tip2.abcca72e.jpeg";